'use client';

import { ReactNode, Suspense, lazy, useMemo } from 'react';

import { useSchemes } from '@personly/libs-providers';

const Modal = lazy(() => import('react-modal'));

const content: Record<string, string | number> = {
  top: '50%',
  left: '50%',
  right: 'auto',
  bottom: 'auto',
  marginRight: '-50%',
  width: '80%',
  transform: 'translate(-50%, -50%)',
  boxShadow: '1px 2px 8px 0 rgba(0, 0, 0, 0.35)',
  border: 0,
  maxWidth: '800px',
  maxHeight: '80%',
  overflowY: 'auto',
};

interface Props {
  children: ReactNode;
  isOpen: boolean;
  consentLabel: string;
}

const Consent = ({ children, isOpen, consentLabel }: Props) => {
  const { cssVariables } = useSchemes();

  const style = useMemo(
    () => ({
      content: {
        ...content,
        backgroundColor: cssVariables.cardBackgroundColor[0],
      },
      overlay: { backgroundColor: 'rgba(17, 17, 17, 0.5)' },
    }),
    [cssVariables]
  );

  return (
    <Suspense>
      <Modal
        testId="consent"
        ariaHideApp={false}
        isOpen={isOpen}
        style={style}
        contentLabel={consentLabel}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
      >
        {children}
      </Modal>
    </Suspense>
  );
};

export default Consent;
